import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CmsConfig,
  FeaturesConfigModule,
  I18nModule,
  provideConfig,
  provideConfigFactory,
  provideDefaultConfig
} from "@spartacus/core";
import {GonvarriAddToCartComponent} from "../../components/gonvarri-add-to-cart/gonvarri-add-to-cart.component";
import {IconModule, ItemCounterModule, OutletModule} from "@spartacus/storefront";
import {ReactiveFormsModule} from "@angular/forms";
import {AddToCartComponent} from "@spartacus/cart/base/components/add-to-cart";
import {
    GonvarriProductNofificationButtonModule
} from "../gonvarri-product-nofification-button/gonvarri-product-nofification-button.module";

@NgModule({
  declarations: [
    GonvarriAddToCartComponent
  ],
    imports: [
        CommonModule,
        I18nModule,
        ItemCounterModule,
        IconModule,
        ReactiveFormsModule,
        OutletModule,
        FeaturesConfigModule,
        GonvarriProductNofificationButtonModule
    ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        GonvarriAddToCartComponent: {
          component: GonvarriAddToCartComponent,
          data: {
            inventoryDisplay: false,
          }
        }
      }
    }),
  ],
  exports: [
    GonvarriAddToCartComponent
  ]
})
export class GonvarriAddToCartModule { }
